import {PlayerAPI, PlayerConfig} from 'bitmovin-player';

import {isNullish} from '../../utils/Utils';

export function getPlayerConfig(player: PlayerAPI | undefined): PlayerConfig | undefined {
  try {
    if (isNullish(player) || isNullish(player.getConfig())) {
      return undefined;
    }

    return player.getConfig();
  } catch (_e) {
    // exception might be thrown if player was destroyed - this is expected, so no need to throw or log the exception
    return undefined;
  }
}
